import { render, staticRenderFns } from "./rds-period.vue?vue&type=template&id=00bcf1b1&scoped=true&"
import script from "./rds-period.vue?vue&type=script&lang=js&"
export * from "./rds-period.vue?vue&type=script&lang=js&"
import style0 from "./rds-period.vue?vue&type=style&index=0&id=00bcf1b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcf1b1",
  null
  
)

export default component.exports